export default __webpack_public_path__ + "f72b4e3cb0102456ab9fe5b614a28834.png";